import React from 'react';
import { Avatar, Box, Button, Dialog, DialogContent, Typography, PaletteColor } from '@mui/material';
import { theme } from '../../../theme';

interface WarningDialogProps {
    open: boolean;
    icon: React.ReactElement;
    iconBgColor?: PaletteColor;
    iconColor?: PaletteColor;
    title: string;
    message: string;
    cancelButtonText: string;
    onCancel: () => void;
}

export const WarningDialog: React.FC<WarningDialogProps> = ({
  open,
  icon,
  iconBgColor = theme.palette.error,
  iconColor = theme.palette.error, 
  title,
  message,
  cancelButtonText,
  onCancel,
}) => (
  <Dialog
    open={open}
    onClose={onCancel}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    sx={{
      '& .MuiDialog-container': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    }}
  >
    <DialogContent>
      <Box
        sx={{
          display: 'flex',
          pb: 2,
          pt: 3,
          px: 3,
        }}
      >
        <Avatar
          sx={{
            backgroundColor: () => iconBgColor[100],
            color: () => iconColor[700],
            mr: 4,
          }}
        >
          {icon}
        </Avatar>
        <div>
          <Typography>{title}</Typography>
          <Typography color="textSecondary"
            sx={{ mt: 1 }}
            variant="textSM">
            {message}
          </Typography>
        </div>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          px: 3,
          py: 1.5,
        }}
      >
        <Button sx={{ mr: 2 }}
          variant="secondary"
          size="md"
          onClick={onCancel}>
          {cancelButtonText}
        </Button>
      </Box>
    </DialogContent>
  </Dialog>
);
